// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgMusic: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M21.956 1.517c.34.252.542.655.542 1.079v14.108c0 1.856-1.806 3.359-4.031 3.359-2.225 0-4.03-1.503-4.03-3.36 0-1.855 1.805-3.358 4.03-3.358.47 0 .924.067 1.344.193V7.424L9.06 10.65v8.742c0 1.856-1.805 3.359-4.03 3.359C2.805 22.75 1 21.247 1 19.391s1.805-3.359 4.03-3.359c.471 0 .925.067 1.344.193V6.627c0-.592.39-1.117.958-1.29l13.436-4.03a1.337 1.337 0 0 1 1.188.21" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgMusic);
export default Memo;
